import { ExternalLink } from "@octopusdeploy/design-system-components";
import MoreInfo from "~/components/MoreInfo/MoreInfo";
import { Note, Text } from "~/components/form";
import environmentNameTemplateInfoImage from "../assets/environment-name-template-info-dark.svg";
import { ConfigWizardHelpLayout } from "./ConfigWizardHelpLayout";
import { ConfigWizardStatusBar } from "./ConfigWizardStatusBar";
export function NameTemplateHelp() {
    return <ConfigWizardHelpLayout title="Name template">The name template uses the release metadata to generate the names of your ephemeral environments when they're created. The example above uses the branch name.</ConfigWizardHelpLayout>;
}
export const nameTemplateHelpImage = {
    src: environmentNameTemplateInfoImage,
    altText: "Graphic of 3 different releases. Release from branch ava/new-feature creates an environment with name ava-new-feature, a release from branch zak/new-feature creates an environment with name zak-new-feature, and a release from branch ben/new-feature creates an environment with name ben-new-feature.",
};
interface NameTemplateContentProps {
    isGitProject: boolean;
    nameTemplateConfig: string;
    setNameTemplateConfig: (config: string) => void;
    isCommittingRunbooksToNewBranch: boolean;
}
export function NameTemplateContent({ isGitProject, nameTemplateConfig, setNameTemplateConfig, isCommittingRunbooksToNewBranch }: NameTemplateContentProps) {
    return (<div>
            <ConfigWizardStatusBar activeStage="Naming" isCommittingRunbooksToNewBranch={isCommittingRunbooksToNewBranch}/>
            <h3>Environment Name Template</h3>
            <Text label="Environment name template" value={nameTemplateConfig} onChange={(value) => setNameTemplateConfig(value)} helperText={<NameTemplateExample isGitProject={isGitProject} setNameTemplateConfig={setNameTemplateConfig}/>}/>
            <ShortNameTemplateInformation />
        </div>);
}
interface NameTemplateExampleProps {
    isGitProject: boolean;
    setNameTemplateConfig: (config: string) => void;
}
export const NameTemplateExample = ({ isGitProject, setNameTemplateConfig }: NameTemplateExampleProps) => {
    const exampleTemplate = isGitProject ? "#{Octopus.Release.Git.BranchName}" : "#{Octopus.Release.CustomFields[My.Custom.Field]}";
    return (<span>
            Example:{" "}
            <a href="#" onClick={(e) => {
            e.preventDefault();
            setNameTemplateConfig(exampleTemplate);
        }}>
                {exampleTemplate}
            </a>
        </span>);
};
export const ShortNameTemplateInformation = () => {
    return (<MoreInfo showLabel="Show name template information" hideLabel="Hide name template information">
            <div>
                <h4>Getting Started</h4>
                <p>You can use variables from your release in your ephemeral environment name using Octostache expressions like this:</p>
                <pre>
                    <code>{"#{Octopus.Release.Number}"}</code>
                </pre>
                <p>You can also set Custom Fields on your release and use these in your ephemeral environment names like this:</p>
                <pre>
                    <code>{"#{Octopus.Release.CustomFields[My.Custom.Field]}"}</code>
                </pre>
                <Note>
                    See <ExternalLink href="systemvariables">system variables documentation</ExternalLink>
                </Note>
                <hr />
            </div>
        </MoreInfo>);
};
